<template>
  <b-modal
    id="add-calculated-field-modal"
    ref="modal"
    title="Add Calculated Field"
    @show="resetAddCalculatedFieldModal"
    @ok="handleOk"
  >
    <div class="p-2">
      <div class="mb-3">
        <b-form-input
          id="calculated-field-name"
          v-model="calculatedField.name"
          placeholder="Name for Calculated Field"
        >
        </b-form-input>
      </div>
      <div v-if="calculatedField.field1">
        <div v-on:click="deleteField(1)" class="selected-field my-2">
          {{field1Display.name}}
        </div>

        <div v-if="field1Display.unit === 'usd'">
          <b-form-radio-group
            id="btn-radios-1"
            v-model="calculatedField.field1.resolution"
            :options="resolutionList"
            buttons
            name="field1-resolution"
          ></b-form-radio-group>
        </div>
      </div>
      <div v-else>
        <div class="mb-3">
          <tag-autocomplete ticker="AYX" v-on:tagSelected="addField1"></tag-autocomplete>
        </div>
      </div>
      <b-form-group class="mb-3">
        <b-form-radio-group
          id="btn-radios-1"
          v-model="calculatedField.operation"
          :options="operationList"
          buttons
          name="radio-button-operation=select"
          class="'hello-world"
        ></b-form-radio-group>
      </b-form-group>

      <div v-if="calculatedField.field2">
        <div v-on:click="deleteField(2)" class="selected-field my-2">
          {{field2Display.name}}
        </div>

        <div v-if="field2Display.unit === 'usd'">
          <b-form-radio-group
            id="field2-resolution"
            v-model="calculatedField.field2.resolution"
            :options="resolutionList"
            buttons
            name="field1-resolution"
          ></b-form-radio-group>
        </div>

      </div>

      <div v-else>
        <div>
          <tag-autocomplete ticker="AYX" v-on:tagSelected="addField2"></tag-autocomplete>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import TagAutocomplete from '@/charts/TagAutocomplete.vue';
import apiCall from '@/assets/js/stockifyApi';
import { CHART_CALCULATED_FIELDS } from '@/assets/js/endpoints';

export default {
  name: 'AddCalculatedFieldDialog',
  components: {
    TagAutocomplete,
  },
  data() {
    return {
      calculatedField: {
        name: null,
        field1: null,
        field2: null,
        operation: null,
      },
      field1Display: null,
      field2Display: null,
      operationList: [
        { text: 'Multiply', value: '*' },
        { text: 'divide', value: '/' },
      ],
      resolutionList: [
        { text: 'Quarterly', value: 'Q' },
        { text: 'Year', value: 'Y' },
      ],
    };
  },
  methods: {
    addCalculatedField() {
    },
    deleteField(field) {
      console.log('hello world');
      console.log(field);
      console.log(this.calculatedField[`field${field}`]);
      this.calculatedField[`field${field}`] = null;
    },
    addField1(tag) {
      this.field1Display = tag;
      this.calculatedField.field1 = {};
      // noinspection JSUnresolvedVariable
      this.calculatedField.field1.src = tag.statement_code;
      this.calculatedField.field1.uuid = tag.uuid;
    },
    addField2(tag) {
      this.field2Display = tag;
      this.calculatedField.field2 = {};
      // noinspection JSUnresolvedVariable
      this.calculatedField.field2.src = tag.statement_code;
      this.calculatedField.field2.uuid = tag.uuid;
    },
    resetAddCalculatedFieldModal() {
      this.calculatedField.name = null;
      this.calculatedField.field1 = null;
      this.calculatedField.field2 = null;
      this.calculatedField.operation = null;
    },
    handleOk() {
      console.log(this.calculatedField);
      apiCall({
        method: 'POST',
        url: CHART_CALCULATED_FIELDS,
        data: this.calculatedField,
      }).then((resp) => {
        console.log(resp.data);
        this.resetAddCalculatedFieldModal();
      });
    },
  },
};
</script>

<style>
  .selected-field {
    line-height: 1.5;
  }
</style>
